
const apiConfig = {
    // Local development API URL
    //apiUrl: 'https://localhost:7095/api/',
    // Production API URL
    //apiUrl: 'https://mga-api.off-ease.com/api/',
    // test API URL
    apiUrl: 'https://sgd-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

